(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/analytics/analytics.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2025 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<section class="analytics">',
'',
'  <date class="stats-conf" model="analytics.date" callback="analytics.load(analytics.role)"></date>',
'',
'  <select class="form-control stats-conf" ng-model="analytics.role" ng-change="analytics.setRole()"',
'    ng-options="role.cn as role.label for role in analytics.roles" chosen>',
'  </select>',
'',
'  <h3>',
'    <span translate>analytics.title</span>',
'    <span ng-if="analytics.role != \'all\'">',
'      <span translate>for</span>',
'      {{analytics.role}}',
'    </span>',
'  </h3>',
'',
'  <hr>',
'',
'  <div class="row">',
'    <stats',
'        data="analytics.requests"',
'        type="\'line\'"',
'        config="analytics.config.requests"',
'        title="\'analytics.requests\'"',
'        class="col-md-6"',
'        csv-config="analytics.requestsOptions"',
'    ></stats>',
'    <stats',
'        data="analytics.layers"',
'        type="\'bar\'"',
'        config="analytics.config.layers"',
'        title="\'analytics.layers\'"',
'        class="col-md-6"',
'        csv-config="analytics.usageOptions"',
'    ></stats>',
'  </div>',
'  <hr>',
'  <div class="row" ng-if="platformInfos.extractorappEnabled">',
'    <stats data="analytics.extractions" type="\'bar\'" config="analytics.config.extractions"',
'           title="\'analytics.extractions\'" class="col-md-4" csv-config="analytics.extractionOptions"/>',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();